import { Phrases } from '@shared/models/locales.model';

export default {
  'Buttons.Cancel': 'الغاء',
  'Buttons.Save': 'حفظ',
  'Buttons.Next': 'التالي',
  'Buttons.SelectFile': 'اختر ملف',
  'Buttons.Confirm': 'تأكيد',
  'Buttons.Find': 'بحث',
  'Buttons.Download': 'تحميل',
  'Placeholder.EnterReason': 'أدخل السبب...',

  components: {
    sortMenu: {
      MostRecent: 'الاكثر تحديثا',
      NameAZ: 'من الاقل الى الاعلى',
      NameZA: 'من الاعلى الى الاقل',
      sort: 'ترتيب',
      HighNoOfPallets: 'اعلي رقم من الالواح',
      LowNoOfPallets: 'اقل رقم من الالواح',
      ALL: 'الكل',
      AMB: 'البيئة',
      Chiller: 'الثلاجة',
      Frozen: 'مجمد',
      Deep_Frozen: 'شديد التجميد',
    },
    activity: {
      theInvoice: 'الفاتورة.',
      successfully: 'تم دفع الفاتورة بنجاح.',
      activity: 'السجل',
      Converted: 'تم تحويل الفاتورة إلى متأخرة',
      system: 'مدار',
    },
    confirmation: {
      cancelTitle: 'تأكيد الإلغاء!',
      cancelText: 'هل أنت متأكد أنك تريد إلغاء هذا؟ سيتم إزالة جميع البيانات المملوءة بشكل دائم ولا يمكن التراجع عنها.',
      cancelDiscard: 'لا ، أبقها',
      cancelConfirm: 'نعم ، إلغاء',
      discard: 'تجاهل',
      confirm: 'تأكيد',
      cancel: 'إلغاء',
    },
    changeLanguage: 'تغيير اللغة',
    lazyDropdown: {
      all: 'كل {{items}}',
      addNew: 'إضافة جديد',
    },
  },
  Errors: {
    NetworkError: 'تم قطع الاتصال بالشبكة، يرجى التحقق من اتصالك وإعادة تحميل التطبيق مرة أخرى!.',
  },
  accordion: {
    OrderID: 'رقم الطلب:',
    Pallet: 'البالتة',
    Items: 'العناصر',
    All: 'كل',
    Orders: 'طلب',
    SealNo: 'رقم الختم',
    ProofOfDelivery: 'اثبات التوصيل',
    Download: 'تحميل',
  },
  Enum: {
    OrderType: {
      StockToCustomerStock: 'نقل المخزون',
      StoTransfer: 'نقل المخزون',
      Z122: 'تحويل المخزون',
      CustomerOutboundOrders: 'نقل الصادرات',
      CustomerReturn: 'إرجاع العملاء',
      CustomerReturnNupcoStock: 'إرجاع العملاء لمخزون Nupco',
      NupcoSalesReturns: 'إرجاعات مبيعات Nupco',
      DistributionOutboundOrder: 'طلب صادر للتوزيع',
      TransferOrders: 'طلبات النقل',
      VendorSupplierReturns: 'إرجاعات الموردين والموردين',
      SalesOrder: 'طلب البيع',
      NupcoRoyalCourt: 'محكمة نوبكو الملكية',
      NupcoDonationIssue: 'مشكلة التبرعات Nupco',
      ScrapOrders: 'طلبات الخردة',
      PrepareOrder: 'تجهيز الطلب',
      SalesWithPrice: 'المبيعات بالسعر',
      ZPG1: 'ZPG1',
      MOIR: 'MOI-R',
    },
    InvoiceAction: {
      CREATED: 'انشئ',
      UPDATED: 'عدل',
      APPROVED: 'وافق',
      REJECTED: 'رفض',
      PAID: 'دفع',
    },
    WccIntegrationStatusType: {
      WAITING_ASSIGNMENT: 'في انتظار المهمة',
      INTEGRATED: 'متكامل',
      INTEGRATION_FAILED: 'فشل التكامل',
      INTEGRATION_IN_PROGRESS: 'التكامل قيد التقدم',
      INTEGRATION_CANCELED: 'تم إلغاء التكامل',
      CANCELATION_FAILED: 'فشل الالغاء',
    },
  },
  shipmentSummary: {
    totalDistance: 'المسافة الكلية',
  },
  km: 'كم',
  hrs: 'س',
  min: 'د',
  AutoCache: 'التخزين المؤقت التلقائي',

  'currency.SAR': 'ر.س',
  'currency.EGP': 'ج.م',
  'Validation.required': '{{field}} مطلوب!',
  'Validation.realNumberValidator': '{{field}} يجب أن يحتوي على أرقام فقط!',
  'Validation.min': '{{field}} يجب ان يكون {{min}} او اكثر!',
  'Validation.max': '{{field}} يجب ان يكون {{max}} او اقل!',
  'Validation.minLength': '{{field}} يجب ان يكون على الاقل {{minLength}} حروف!',
  'Validation.maxLength': '{{field}} يجب ان يكون على الاكثر {{maxLength}} حروف!',
  'Validation.minlength': '{{field}} يجب ان يكون على الاقل {{minLength}} حروف!',
  'Validation.maxlength': '{{field}} يجب ان يكون على الاكثر {{maxLength}} حروف!',
  "Validation.pastDate": "يجب أن يكون التاريخ والوقت في المستقبل.",
  "Validation.invalidPhoneNumberLength": "طول رقم الهاتف غير صالح",
  'cardItemsList.Orders': 'الطلبات',
  'cardItemsList.Pallet': 'باليت',
  'cardItemsList.Items': 'عناصر',
  'cardItemsList.PalletItems': 'عناصر البالتة',
  'cardItemsList.LineItems': 'Line Items',
  'cardItemsList.NoPalletSelected': 'لم يتم تحديد أي باليت',
  'cardItemsList.OnceYouSelectTheDetailsWillAppearHere': 'بمجرد تحديدك، ستظهر التفاصيل هنا',
  'cardItemsList.Qty': 'الكمية',
  'cardItemsList.Accepted': 'مقبول',
  'cardItemsList.Returned': 'مرتجع',
  'cardItemsList.Batch': 'الدفعة',
  'cardItemsList.EmptyPalletHint': 'عندما تقوم بالاختيار ستظهر التفاصيل هنا.',
  'announcementBar.news': 'أخبار',
  'announcementBar.link': 'رابط',
  'Important': 'هام!',
  'CompleteYourInformation': 'استكمل بياناتك للحصول على شحنات موثوقة مع شركاء معتمدين، وفواتير رسمية، وتتبع لحظي.',
  'CompleteInformation': 'استكمل بياناتي',
  'Platform': 'منصة النقل',
} as Phrases;
